import React from "react";
import styles from "./ContentCard.module.scss";

export const ContentCard = ({
  headerImgSrc,
  iconName = "",
  title,
  headerContent = <></>,
  bodyContent,
  footerContent = <></>,
  classes = "",
}) => {
  return (
    <div className={`card ${styles["content-card"]} ${classes}`}>
      <div className={`${styles.header}`}>
        <div className={`${styles.label}`}>
          {headerImgSrc && (
            <img
              className={styles["header-img"]}
              src={headerImgSrc}
              alt={title}
            />
          )}
          {iconName && <i className={`fa-solid ${iconName}`}></i>}
          {title}
        </div>
        <div className={`${styles.content}`}>{headerContent}</div>
      </div>

      <div className={`${styles.body}`}>{bodyContent}</div>
      {footerContent && <div>{footerContent}</div>}
    </div>
  );
};
